import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthenComponent } from './_controller/authen.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [AuthenComponent],
  exports: []
})
export class AuthenModule { }


// WEBPACK FOOTER //
// ./src/app/authen/authen.module.ts